import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text } from '@common-fe/common-fe';

import { Modal } from '@/components';
import { DocumentDetailsCard } from '@/modules/UseMyMoney/components';

interface Props {
  onClose: () => void;
}

const WhyDoesItMatterModal: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      visible
      onSetVisible={(visible) => {
        if (!visible) onClose();
      }}
      testId="why-does-it-matter"
    >
      <Text data-testid="why-does-it-matter_title" size="2xl" weight={700} textAlign="center">
        {t('Why Does It Matter?')}
      </Text>

      <Box margin={{ top: 'spacing24' }} gap="spacing12">
        <Box
          data-testid="why-does-it-matter_info-block"
          round="container2Round"
          background="infoContainer"
          pad={{ vertical: 'spacing12', horizontal: 'spacing16' }}
          gap="spacing8"
        >
          <Text data-testid="why-does-it-matter_paragraph-1">
            {t(
              'Depending on the date and type of service, your plan and/or the IRS may require supporting documentation to approve this expense.'
            )}
          </Text>
          <Text data-testid="why-does-it-matter_paragraph-2">
            {t(
              'Plans requiring documentation cannot make payments to its participants or any providers without proof of the expense.'
            )}
          </Text>
        </Box>

        <DocumentDetailsCard />
      </Box>
    </Modal>
  );
};

export default WhyDoesItMatterModal;
